<section class="">
  <!-- Form -->
  <form [formGroup]="addInstitutionForm" class="space-y-5">
    <!-- Name & Address -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <app-custom-input [label]="'Name of institution'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Type name here'" formControlName="name"></app-custom-input>
      <app-custom-input [label]="'Address of institution'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Enter address here'" formControlName="address"></app-custom-input>
    </div>

    <!-- Contact & Email -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <app-custom-input [label]="'Contact number'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Type phone number here'" formControlName="contact"></app-custom-input>
      <app-custom-input [label]="'Email Address'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Enter email here'" formControlName="email"></app-custom-input>
    </div>

    <!-- Description -->
    <div>
      <app-custom-input [label]="'Description'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Type description here'" formControlName="description"></app-custom-input>
    </div>

    <!-- Assigned To (Business Development) -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">
        Assigned To (Business Development)
      </label>
      <app-custom-select-input [options]="assignedToOptions" [searchable]="true"
        [searchPlaceholder]="'Search staff...'"
        [placeholder]="isLoadingBdUsers ? 'Loading staff...' : 'Select a Business Development staff member'"
        formControlName="assignedTo"></app-custom-select-input>
      @if (bdUsersUnavailable) {
      <p class="text-xs text-slate-400 mt-2">No Business Development staff available.</p>
      }
      @if (addInstitutionForm.get('assignedTo')?.hasError('apiError')) {
      <div class="text-error text-xs mt-2">{{ addInstitutionForm.get('assignedTo')?.errors?.['apiError'] }}</div>
      }
    </div>

    <!-- Auto Repayment Toggle -->
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <div class="flex items-center justify-between">
        <div>
          <label class="text-xs font-medium text-slate-900 dark:text-white block mb-1">Auto Repayment <span
              class="text-error">*</span></label>
          <p class="text-xs text-slate-500 dark:text-slate-400">Enable automatic loan repayment</p>
        </div>
        <button type="button" (click)="toggleAutoRepayment()"
          [style.background-color]="autoRepaymentValue ? '#0D76BA' : '#CBD5E1'"
          class="relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none">
          <span [class]="autoRepaymentValue ? 'translate-x-7' : 'translate-x-0'"
            class="pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
      </div>
      <div class="mt-3 flex items-center gap-2 text-sm">
        <span [class]="!autoRepaymentValue ? 'text-slate-900 dark:text-white font-medium' : 'text-slate-500 dark:text-slate-400'">No</span>
        <span [class]="autoRepaymentValue ? 'text-primary-800 dark:text-primary-400 font-medium' : 'text-slate-500 dark:text-slate-400'">Yes</span>
      </div>
    </div>

    <!-- NIA Verification Required Toggle -->
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <div class="flex items-center justify-between">
        <div>
          <label class="text-xs font-medium text-slate-900 dark:text-white block mb-1">NIA Verification Required <span class="text-error">*</span></label>
          <p class="text-xs text-slate-500 dark:text-slate-400">Require NIA identity verification</p>
        </div>
        <button type="button" (click)="toggleIsNiaVerificationRequired()"
          [style.background-color]="isNiaVerificationRequiredValue ? '#0D76BA' : '#CBD5E1'"
          class="relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none">
          <span [class]="isNiaVerificationRequiredValue ? 'translate-x-7' : 'translate-x-0'"
            class="pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
      </div>
      <div class="mt-3 flex items-center gap-2 text-sm">
        <span [class]="!isNiaVerificationRequiredValue ? 'text-slate-900 dark:text-white font-medium' : 'text-slate-500 dark:text-slate-400'">No</span>
        <span [class]="isNiaVerificationRequiredValue ? 'text-primary-800 dark:text-primary-400 font-medium' : 'text-slate-500 dark:text-slate-400'">Yes</span>
      </div>
    </div>

    <!-- Validate Loan Parameter Toggle -->
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <div class="flex items-center justify-between">
        <div>
          <label class="text-xs font-medium text-slate-900 dark:text-white block mb-1">Validate Loan Parameter <span class="text-error">*</span></label>
          <p class="text-xs text-slate-500 dark:text-slate-400">Enable loan parameter validation</p>
        </div>
        <button type="button" (click)="toggleValidateLoanParameter()"
          [style.background-color]="validateLoanParameterValue ? '#0D76BA' : '#CBD5E1'"
          class="relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none">
          <span [class]="validateLoanParameterValue ? 'translate-x-7' : 'translate-x-0'"
            class="pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
      </div>
      <div class="mt-3 flex items-center gap-2 text-sm">
        <span [class]="!validateLoanParameterValue ? 'text-slate-900 dark:text-white font-medium' : 'text-slate-500 dark:text-slate-400'">No</span>
        <span [class]="validateLoanParameterValue ? 'text-primary-800 dark:text-primary-400 font-medium' : 'text-slate-500 dark:text-slate-400'">Yes</span>
      </div>
    </div>

    <!-- CSV Upload (if showAddCSV is true) -->
    @if (showAddCSV()) {
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <label class="text-xs font-medium text-slate-900 dark:text-white mb-3 block">Assign users to this institution</label>

      <!-- View Sample CSV -->
      <div (click)="downloadSampleCSV()"
        class="flex items-center gap-2 mb-3 text-primary-800 dark:text-primary-400 cursor-pointer hover:text-primary-900 transition-colors">
        <p class="text-xs font-normal">View sample csv</p>
        <img [src]="_images.downloadColored" alt="download" class="w-4 h-4" />
      </div>

      <!-- File Upload Area -->
      <div class="border-2 border-dashed border-gray-300 dark:border-slate-600 rounded-lg hover:border-primary-500 transition-colors">
        @if (csvFile != null) {
        <!-- Uploaded File -->
        <div class="p-4">
          <div class="flex items-center justify-between mb-2">
            <p class="text-xs font-normal text-slate-900 dark:text-white">{{ csvFile.name }}</p>
            <button type="button" (click)="removeCSVFile()" class="p-1 hover:bg-red-50 rounded transition-colors">
              <img [src]="_images.deleteIcon" alt="delete" class="w-4 h-4"
                style="filter: brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(1352%) hue-rotate(331deg) brightness(99%) contrast(96%);" />
            </button>
          </div>
          <div class="flex items-center gap-3">
            <div class="flex-1 h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
              <div class="h-full bg-primary-800" style="width: 100%"></div>
            </div>
            <p class="text-xs font-normal text-primary-800 dark:text-primary-400">100%</p>
          </div>
        </div>
        } @else {
        <!-- Upload Prompt -->
        <div (click)="csvFileInput.click()"
          class="p-8 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-800 transition-colors">
          <img [src]="_images.downloadColored" alt="upload" class="w-12 h-12 mb-3 opacity-50" />
          <p class="text-sm text-slate-600 dark:text-slate-400 font-medium">Upload your file here</p>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Click to browse</p>
        </div>

        <input type="file" style="display: none" #csvFileInput (change)="onCSVFileSelected($event)" accept=".csv" />
        }
      </div>
    </div>
    }

    <!-- Documents Upload -->
    <div class="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
      <label class="text-xs font-medium text-slate-900 dark:text-white mb-3 block">Upload Documents</label>

      <!-- File Upload Area -->
      <div class="border-2 border-dashed border-gray-300 dark:border-slate-600 rounded-lg hover:border-primary-500 transition-colors">
        @if (documents.length > 0) {
        <!-- Uploaded Files List -->
        <div class="p-4 space-y-3">
          @for (document of documents; track $index) {
          <div class="bg-white dark:bg-slate-800 rounded-lg p-3 border border-gray-200 dark:border-slate-700">
            <div class="flex items-center justify-between mb-2">
              <p class="text-xs font-normal text-slate-900 dark:text-white">{{ document.name }}</p>
              <button type="button" (click)="removeDocument($index)"
                class="p-1 hover:bg-red-50 rounded transition-colors">
                <img [src]="_images.deleteIcon" alt="delete" class="w-4 h-4"
                  style="filter: brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(1352%) hue-rotate(331deg) brightness(99%) contrast(96%);" />
              </button>
            </div>
            <div class="flex items-center gap-3">
              <div class="flex-1 h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
                <div class="h-full bg-primary-800" style="width: 100%"></div>
              </div>
              <p class="text-xs font-normal text-primary-800 dark:text-primary-400">100%</p>
            </div>
          </div>
          }
          <!-- Add More Files Button -->
          <div (click)="fileInput.click()"
            class="mt-3 p-3 flex items-center justify-center cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-800 rounded-lg border border-gray-300 dark:border-slate-600 transition-colors">
            <p class="text-xs text-primary-800 dark:text-primary-400 font-medium">+ Add more documents</p>
          </div>
        </div>
        } @else {
        <!-- Upload Prompt -->
        <div (click)="fileInput.click()"
          class="p-8 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-800 transition-colors">
          <img [src]="_images.downloadColored" alt="upload" class="w-12 h-12 mb-3 opacity-50" />
          <p class="text-sm text-slate-600 dark:text-slate-400 font-medium">Upload your documents here</p>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Click to browse or select multiple files</p>
        </div>
        }

        <input type="file" style="display: none" #fileInput (change)="onFileSelected($event)" multiple />
      </div>
    </div>

    <!-- Submit Button -->
    <div class="pt-4">
      <app-primary-button [text]="institution() ? 'Update' : 'Confirm'" [isLoading]="isLoading"
        (onClickEvent)="onSubmit()"></app-primary-button>
    </div>
  </form>
</section>